const WIDGET = '.menu-item-has-children';
const ACTIVECLASS = 'is-open';
const IS_COARSE = matchMedia('(pointer:coarse)').matches;

export class Dropdown {
  constructor() {
    this.elements = document.querySelectorAll(WIDGET);
  }

  init = () => {
    this.elements.forEach((el) => {
      const button = el.querySelector('.dropdown__btn');

      if (button) {
        button.addEventListener('click', this.clickHandler, false);
      }
    });
  };

  clickHandler = (e) => {
    e.stopPropagation();  // Zabráníme propagaci události

    const button = e.currentTarget;
    const widget = button.closest(WIDGET);

    // Pouze přepínáme třídu, aniž bychom zavírali jiné položky
    widget.classList.toggle(ACTIVECLASS);
  };

  // Tato metoda již není potřeba, ale ponechávám ji pro případné další použití
  closeActive = () => {
    const openDropdowns = document.querySelectorAll(`${WIDGET}.${ACTIVECLASS}`);
    openDropdowns.forEach((dropdown) => {
      dropdown.classList.remove(ACTIVECLASS);
    });
  };
}

if (IS_COARSE) {
  const DropdownObject = new Dropdown();
  DropdownObject.init();
}
